import React, { Component } from 'react';
import Envelope from './Envelope';

class Run extends Component {
  constructor(props) {
    super(props)
    this.state = { envelope: {
      htmlValue: '',
      cssValue: '',
      jsValue: '',
      tableValue: []
    } }
  }

  render() {
    return  (
      <Envelope user={this.props.user} isNew={true} envelope={this.state.envelope}/>
    )
  }
}

export default Run



// WEBPACK FOOTER //
// ./src/Create.js